import { render, staticRenderFns } from "./dev-realtime-info.vue?vue&type=template&id=6b076695&scoped=true&"
import script from "./dev-realtime-info.vue?vue&type=script&lang=js&"
export * from "./dev-realtime-info.vue?vue&type=script&lang=js&"
import style0 from "./dev-realtime-info.vue?vue&type=style&index=0&id=6b076695&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b076695",
  null
  
)

export default component.exports